import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Card, CardContent, TextField, Button, Stack } from '@mui/material';
import { configInplaySchema, ConfigInplayFormValues } from '../../../validation/configInplaySchema';
import { ConfigInplay, ConfigInplayInput } from '../../../services/configInplayService';

export interface ConfigInplayFormProps {
  initialData: ConfigInplay | null;
  onSubmit: (data: ConfigInplayInput) => Promise<ConfigInplay>;
}

const ConfigInplayForm: React.FC<ConfigInplayFormProps> = ({ initialData, onSubmit }) => {
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
  } = useForm<ConfigInplayFormValues>({
    resolver: zodResolver(configInplaySchema),
    defaultValues: {
      emailAdministracao: initialData?.emailAdministracao ?? '',
    },
  });

  const submitHandler = async (values: ConfigInplayFormValues) => {
    await onSubmit({ emailAdministracao: values.emailAdministracao });
  };

  return (
    <Card variant="outlined">
      <CardContent>
        <form onSubmit={handleSubmit(submitHandler)}>
          <Controller
            name="emailAdministracao"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="E-mail da administração"
                fullWidth
                error={!!errors.emailAdministracao}
                helperText={errors.emailAdministracao?.message as string}
              />
            )}
          />

          <Stack direction="row" justifyContent="flex-end" sx={{ mt: 2 }}>
            <Button type="submit" variant="contained" disabled={isSubmitting}>
              {isSubmitting ? 'Salvando...' : 'Salvar'}
            </Button>
          </Stack>
        </form>
      </CardContent>
    </Card>
  );
};

export default ConfigInplayForm;
